import { render } from "./Sv003.vue?vue&type=template&id=9d49667a&scoped=true"
import script from "./Sv003.vue?vue&type=script&lang=js"
export * from "./Sv003.vue?vue&type=script&lang=js"

import "./Sv003.vue?vue&type=style&index=0&id=9d49667a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d49667a"]])

export default __exports__